/**
 * Generates the SSAS deep link for self-service password reset.
 * Redirects the user through the /loginauth flow with changePassword pre-selected.
 *
 * Identical function from:
 * - ss-ui-client/src/services/password-reset-link-generator.js
 * - shipstation-lite/src/auth/generate-password-reset-link.ts
 */
export const generatePasswordResetLink = (username: string): string => {
  const encodedUsername = encodeURIComponent(username);
  return `/loginauth?flow=changePassword&username_or_email=${encodedUsername}&auto_invoke=true&voluntary=true`;
};
